import { GetFrontDoorsDocument, GetFrontDoorsQuery } from "../../../../types/graphql";
import { AnyQueryArgs, ProviderRequestMethod, GetListQueryResolver, IRecordObject } from "../types";

export interface IFrontDoorRecord extends IRecordObject {
  label: string;
}

const listQuery: GetListQueryResolver<GetFrontDoorsQuery, IFrontDoorRecord> = () => ({
  query: GetFrontDoorsDocument,
  variables: {},
  parseResponse: ({ data }) => ({
    data: data.frontDoors.map(({ id, label }) => ({ id, label: label || "" })),
    total: data.frontDoors.length,
  }),
});

export const frontDoorQuery = (fetchType: ProviderRequestMethod): AnyQueryArgs => {
  switch (fetchType) {
    case ProviderRequestMethod.GET_LIST:
      return listQuery();
    default:
      throw new Error(`fetchType ${fetchType} not recognised for calls`);
  }
};
